import React from "react";

export default function ContactPage() {
  // Oppdater adressen til deres faktiske beliggenhet
  const address = "Industrivegen 14, 4120 Tau";
  const email = "post@ryfylkeutleie.no";
  const phone = "40491955";

  // Google Maps – funker uten API-nøkkel for en enkel “q=” embed
  const mapsEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
  const mapsOpenLink = `https://www.google.com/maps?q=${encodeURIComponent(address)}`;

  // Valgfri telefonformattering i visning
  const phoneDisplay = "404 91 955";

  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-[#000099] mb-2">Kontakt oss</h1>
      <p className="text-gray-600 mb-6">
        Ta gjerne kontakt på e-post eller telefon. Du kan også finne oss på kartet under.
      </p>

      {/* Kontaktinfo-boks */}
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 mb-8">
        <div className="font-semibold text-[#000099] text-lg">Ryfylke Utleie AS (Org.nr. 917 538 379)</div>
        <div className="mt-1">
          E-post:{" "}
          <a className="underline" href={`mailto:${email}`}>
            {email}
          </a>
        </div>
        <div className="mt-1">
          Telefon:{" "}
          <a className="underline" href={`tel:${phone}`} title="Ring oss">
            {phoneDisplay}
          </a>
        </div>
        <div className="mt-1 text-gray-700">
          Adresse: <span className="italic">{address}</span>
        </div>
        <div className="mt-3 flex gap-3">
          <a
            href={`mailto:${email}`}
            className="bg-white border px-4 py-2 rounded hover:bg-gray-50 transition text-[#000099]"
          >
            Send e-post
          </a>
          <a
            href={`tel:${phone}`}
            className="bg-[#000099] text-white px-4 py-2 rounded hover:bg-blue-900 transition"
          >
            Ring oss
          </a>
        </div>
      </div>

      {/* Kart */}
      <div>
        <h2 className="text-xl font-semibold text-[#000099] mb-3">Her finner du oss</h2>
        <div className="relative w-full rounded-xl overflow-hidden shadow border">
          {/* 16:9 container */}
          <div className="pb-[56.25%] relative">
            <iframe
              title="Kart – Ryfylke Utleie"
              src={mapsEmbedSrc}
              className="absolute inset-0 w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
        <a
          href={mapsOpenLink}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block mt-3 underline text-[#000099] hover:text-blue-800"
        >
          Åpne i Google Maps
        </a>
      </div>
    </div>
  );
}
